<template>
    <div class="login">
        <div class="lgleft">
            <div class="letext1">
                购物用助花

            </div>
            <div class="letext1" style="margin-top: 26px;">
                财运到我家

            </div>
            <div class="huawawa">
                <img src="../assets/huawawa.png" alt="">
            </div>
        </div>
        <div class="lgright">
            <div class="zhuhua">
                <img src="../assets/zhuhua.png" alt="">
            </div>
            <div class="rtext">欢迎登录<br>
                助花商城服务台</div>
            <div class="zhulogin">
                <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
                    <el-tab-pane label="账户密码登录" name="first">
                        <div class="zhanghao" :style="{ 'borderColor': zhangkong ? '#E02020' : '' }">
                            <div class="zl">
                                <div style="margin-right: 8px;height: 16px;">
                                    <img src="../assets/zhanghu.png" alt="">
                                </div>
                                <div>
                                    账户
                                </div>
                            </div>
                            <div class="zr">
                                <input type="text" placeholder="请输入账号" v-model="zhanghao">
                            </div>
                            <div :class="zhangkong ? 'kong' : 'kongnone'">请输入账户名</div>


                        </div>
                        <div class="zhanghao" style="margin-top: 34px;" :style="{ 'borderColor': mikong ? '#E02020' : '' }">
                            <div class="zl">
                                <div style="margin-right: 8px;height: 16px;">
                                    <img src="../assets/zhanghu.png" alt="">
                                </div>
                                <div>
                                    密码
                                </div>
                            </div>
                            <div class="zr">
                                <input type="password" placeholder="请输入密码" v-model="mima">
                            </div>
                            <div :class="mikong ? 'kong' : 'kongnone'">请输入密码</div>

                        </div>
                        <div class="zhidong">
                            <label><input type="checkbox" id="test" value="11">自动登录</label>
                        </div>
                        <div class="denglu" @click="login">
                            登 录
                        </div>


                    </el-tab-pane>
                    <!-- <el-tab-pane label="手机号登录" name="second">Config</el-tab-pane> -->
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import api from '@/api/api';
import store from '@/api/store';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex';
const storex = useStore();
const router = useRouter()
const activeName = ref('first')
const handleClick = (tab, event) => {
    console.log(tab, event)
}
let zhanghao = ref('')
let mima = ref('')
let mikong = ref(false)
let zhangkong = ref(false)

const login = async () => {

    zhangkong.value = zhanghao.value.length < 1
    mikong.value = mima.value.length < 1
    if (!mikong.value && !zhangkong.value) {
        let data = {
            username: zhanghao.value,
            password: mima.value
        }
        const res = await api.login(data)
        console.log(data)
        if (res.success) {
            sessionStorage.setItem('relogin', true)
            localStorage.setItem('user', JSON.stringify(res.data));
            storex.commit('sethomebgc', '会员管理');
            getAdminDetails(zhanghao.value)
        } else {
            console.log('账号或密码错误')
            ElMessage({
                showClose: true,
                message: '账号或密码错误!',
                type: 'error',
            })
        }

    }
}
const getAdminDetails = async (user) => {
    const res = await store.getAdminDetails(user)
    localStorage.setItem('usermassage', JSON.stringify(res.data));
    if(res.success){
        router.push('/home/viplist')
    }else {
            console.log('账号或密码错误')
            ElMessage({
                showClose: true,
                message: '账号信息获取错误!',
                type: 'error',
            })
        }
}
</script>

<style lang="scss" scoped>
::v-deep .demo-tabs {
    .el-tabs__header {}

    .el-tabs__nav-wrap {
        .el-tabs__nav-scroll {

            .el-tabs__nav {
                .is-active {
                    color: #30A46C !important;
                }

                .el-tabs__item {
                    height: 45px !important;
                    color: rgba(0, 0, 0, 0.65);
                }

                .el-tabs__active-bar {
                    background-color: #30A46C;
                }
            }


        }

        &::after {
            background-color: #fff !important;
        }
    }


    #tab-first {}
}

.login {
    width: 100%;
    height: 100vh;
    min-height: 828px;
    min-width: 1440px;
    display: flex;

    .lgleft {
        width: 44%;
        height: 100%;
        background: #2DAF18;
        padding-top: 103px;
        box-sizing: border-box;


        .letext1 {
            width: 300px;
            height: 60px;
            font-size: 60px;
            color: rgba(255, 255, 255, 0.85);
            line-height: 60px;
            margin: 0 auto;
        }

        .huawawa {
            width: 296px;
            height: 414px;
            margin: 57px auto;

            img {
                width: 100%;
                height: 100%;
            }
        }

    }

    .lgright {
        width: 66%;
        height: 100%;
        padding-top: 124px;
        box-sizing: border-box;

        .zhuhua {
            width: 93px;
            height: 32px;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;

            }
        }

        .rtext {
            margin: 30px auto;
            text-align: center;
            font-size: 33px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 46px;
        }

        .zhulogin {
            width: 368px;
            height: 273px;
            margin: 64px auto;

            .zhanghao {
                width: 100%;
                height: 40px;
                border-radius: 8px;
                border: 1px solid #D9D9D9;
                box-sizing: border-box;
                margin-top: 24px;
                display: flex;
                align-items: center;
                padding-left: 12px;
                box-sizing: border-box;
                position: relative;

                .zl {
                    display: flex;
                    align-items: center;
                    margin-right: 14px;

                    img {
                        width: 16px;
                        height: 16px;

                    }
                }

                .zr {
                    input {
                        background: none;
                        outline: none;
                        border: 0px;
                        width: 270px;
                    }
                }

                .kong {
                    position: absolute;
                    font-size: 14px;
                    font-weight: 400;
                    color: #F5222D;
                    left: 7px;
                    bottom: -27px;
                }

                .kongnone {
                    display: none;
                }
            }

            .zhidong {

                margin-top: 25px;
                color: rgba(0, 0, 0, 0.65);
                font-size: 14px;

                input {
                    width: 16px;
                    height: 16px;
                }
            }

            .denglu {
                width: 100%;

                height: 40px;
                background: #30A46C;
                font-size: 16px;
                font-weight: 400;
                color: #FFFFFF;
                text-align: center;
                line-height: 40px;
                margin-top: 21px;
                cursor: pointer;
            }

        }
    }
}
</style>